import React from 'react'

/**
 * AbwaabPlus EmptyState — a centered, encouraging pattern: a large emoji over a
 * short reassuring line, optionally a CTA. Never a cold "no data".
 */
export interface AbwEmptyStateProps {
	emoji?: React.ReactNode
	message?: React.ReactNode
	action?: React.ReactNode
	style?: React.CSSProperties
}

export function EmptyState({ emoji = '📭', message, action, style }: AbwEmptyStateProps) {
	return (
		<div style={{ textAlign: 'center', padding: 24, ...style }}>
			<div style={{ fontSize: 40, lineHeight: 1, marginBottom: 8 }}>{emoji}</div>
			{message && <div style={{ font: 'var(--text-body)', color: 'var(--text-secondary)' }}>{message}</div>}
			{action && <div style={{ marginTop: 12, display: 'inline-flex' }}>{action}</div>}
		</div>
	)
}
